import { parsePhoneNumberFromString, type PhoneNumber } from "libphonenumber-js";

export const PHONE_INVALID_US_MESSAGE = "Enter a valid US phone number.";

/** @deprecated Use {@link PHONE_INVALID_US_MESSAGE}. */
export const PHONE_TEN_DIGITS_MESSAGE = PHONE_INVALID_US_MESSAGE;

/** @deprecated Invalid numbers fail {@link isValidUsPhone} via libphonenumber-js. */
export const PHONE_NO_LETTERS_MESSAGE = PHONE_INVALID_US_MESSAGE;

export function parseUsPhoneNumber(value: string): PhoneNumber | undefined {
  const trimmed = value.trim();
  if (!trimmed) {
    return undefined;
  }
  return parsePhoneNumberFromString(trimmed, "US") ?? undefined;
}

export function isValidUsPhone(value: string): boolean {
  if (/[a-zA-Z]/.test(value)) {
    return false;
  }
  const phone = parseUsPhoneNumber(value);
  return Boolean(phone && phone.country === "US" && phone.isValid());
}

/** Canonical storage format (E.164), e.g. `+12065550199`. */
export function normalizeUsPhoneE164(value: string): string {
  const phone = parseUsPhoneNumber(value);
  if (!phone?.isValid() || phone.country !== "US") {
    return "";
  }
  return phone.number;
}

/** Ten-digit national number when valid; otherwise a digits-only fallback for display. */
export function usPhoneDigits(input: string): string {
  const phone = parseUsPhoneNumber(input);
  if (phone?.isValid() && phone.country === "US") {
    return phone.nationalNumber;
  }
  const cleaned = input.replace(/\D/g, "");
  return cleaned.length === 11 && cleaned.startsWith("1") ? cleaned.slice(1) : cleaned;
}

export function usPhoneDigitCount(input: string): number {
  return usPhoneDigits(input).length;
}

export function isValidOptionalUsPhone(value: string | null | undefined): boolean {
  if (value == null || value.trim() === "") {
    return true;
  }
  return isValidUsPhone(value);
}

export function formatUsPhoneNational(value: string): string {
  const phone = parseUsPhoneNumber(value);
  if (phone?.isValid() && phone.country === "US") {
    return phone.formatNational();
  }
  const digits = usPhoneDigits(value);
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  return value.trim();
}
